// extracted by mini-css-extract-plugin
export default {"textarea":"kFfUgs_6wND6QBTcpnuC"};